import React from "react";
import { Link } from "react-router-dom";

function ProductList( { products }) {

    return(
        <>

            { products.map((product, key) => (
                <Link className='link visited' key={key} to={`/product/${product.name}`}>
                    <div className="innerContainer">
                        <div className="innerProductContainer">
                            <h2 className = "header">{product.name}</h2>
                            <h3 className = "header">$ {product.price}</h3>
                        </div>
                        <p className="p">{product.description.substring(0,150)}</p>
                    </div>
                </Link>
            ))}
        </>
    );
}

export default ProductList;